import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SynopsisState {
  synopsisData: any;
  // ... other state properties
}

const initialState: SynopsisState = {
  synopsisData: {},
  // ... other initial state
};

const synopsisSlice = createSlice({
  name: 'synopsis',
  initialState,
  reducers: {
    setSynopsisData: (state, action: PayloadAction<any>) => {
      state.synopsisData = action.payload;
    },
    // ... other reducers
  }
});

export const { setSynopsisData } = synopsisSlice.actions;
export default synopsisSlice.reducer; 